// get the distance (in meters) between two places
// https://en.wikipedia.org/wiki/Haversine_formula
export default function( place1, place2 ) {
  // Radius of the earth in meters
  const R = 6371000;
  const { sin, cos, atan2, sqrt, PI } = Math;
  const r = d => d * ( PI / 180 );
  const dLat = r( place2.lat - place1.lat );
  const dLon = r( place2.lng - place1.lng );
  const a =
    sin( dLat / 2 ) * sin( dLat / 2 ) +
    cos( r( place1.lat ) ) * cos( r( place2.lat ) ) *
    sin( dLon / 2 ) * sin( dLon / 2 );
  const c = 2 * atan2( sqrt( a ), sqrt( 1 - a ) );
  const d = R * c;

  return d;
};
